import React from "react";
import useShowLoader from "../common/loading-widgets/useShowLoader";
import useContentModal from "../common/modals/useContentModal";
import ActionLink from "../common/widgets/ActionLink";
import UpdatePasswordForm from "./UpdatePasswordForm";
import useTranslationCandidates from "../candidates/useTranslationCandidates";
import useSignOut from "../authentication-no-ui/useSignOut";

export default function UpdatePasswordButton(props) {

  const { t, loading: tLoading } = useTranslationCandidates();
  const { signOut, loading, ready: signOutReady } = useSignOut();

  useShowLoader(loading || !signOutReady || tLoading, "UpdatePasswordButton");

  const {ContentModal: UpdatePasswordModal, show: showUpdatePasswordModal, hide: hideUpdatePasswordModal} = useContentModal();


  const onClickUpdate = () => {
    showUpdatePasswordModal(updatePasswordForm);
  }

  const onPasswordUpdated = () => {
    hideUpdatePasswordModal();
    signOut();
  };

  const updatePasswordForm = <UpdatePasswordForm onAbort={hideUpdatePasswordModal} onSuccess={onPasswordUpdated}/>;

  return (
    <>
      {UpdatePasswordModal}
        <ActionLink onClick={onClickUpdate} >{t("authentication-ui:recruiters_profile_update_password")}</ActionLink>
    </>
  );
}
